(function () {
  'use strict';

  var newsletterOrigin = null;

  function attributeValue(element, name, fallback) {
    var value = element.getAttribute(name);
    return value === null ? fallback : value;
  }

  function arrangeFooter() {
    var footer = document.querySelector('footer');
    if (!footer) return;

    var newsletter = footer.querySelector('.footer-content');
    var newsletterSection = newsletter && newsletter.closest('.shopify-section');
    var signature = footer.querySelector('.mdc-footer-signature');
    var signatureSection = signature && signature.closest('.shopify-section');
    var newsletterFirst = attributeValue(footer, 'data-mdc-newsletter-first', 'true') !== 'false';

    if (newsletterOrigin && newsletterOrigin.element !== newsletterSection) {
      if (!newsletterOrigin.element.isConnected && newsletterSection && newsletterOrigin.parent === newsletterSection.parentNode) {
        newsletterOrigin.element = newsletterSection;
      } else {
        newsletterOrigin = null;
      }
    }

    if (newsletterFirst && newsletterSection && signatureSection && newsletterSection.nextElementSibling !== signatureSection) {
      if (!newsletterOrigin) {
        newsletterOrigin = {
          element: newsletterSection,
          parent: newsletterSection.parentNode,
          next: newsletterSection.nextSibling
        };
      }
      signatureSection.parentNode.insertBefore(newsletterSection, signatureSection);
    } else if (!newsletterFirst && newsletterOrigin) {
      if (newsletterOrigin.element === newsletterSection && newsletterOrigin.parent.isConnected) {
        var next = newsletterOrigin.next;
        newsletterOrigin.parent.insertBefore(newsletterSection, next && next.parentNode === newsletterOrigin.parent ? next : null);
      }
      newsletterOrigin = null;
    }

    var email = footer.querySelector('.email-signup__input');
    if (email) email.setAttribute('placeholder', attributeValue(footer, 'data-mdc-newsletter-placeholder', 'Votre adresse e-mail'));

    var form = footer.querySelector('.email-signup__form');
    if (form) {
      var newsletterNote = form.querySelector('.mdc-newsletter-note');
      if (!newsletterNote) {
        newsletterNote = document.createElement('p');
        newsletterNote.className = 'mdc-newsletter-note';
        form.appendChild(newsletterNote);
      }
      newsletterNote.textContent = attributeValue(footer, 'data-mdc-newsletter-note', 'Inscription gratuite · Désinscription à tout moment');
    }

    var payments = footer.querySelector('.mdc-shopify-payments');
    var paymentLabel = payments && payments.querySelector('.mdc-shopify-payments__label');
    if (payments && paymentLabel) {
      var heading = payments.querySelector('.mdc-payment-heading');
      if (!heading) {
        heading = document.createElement('div');
        heading.className = 'mdc-payment-heading';
        paymentLabel.before(heading);
        heading.appendChild(paymentLabel);
      }
      paymentLabel.textContent = attributeValue(payments, 'data-mdc-payment-heading', 'Moyens de paiement acceptés');

      var paymentNote = heading.querySelector('.mdc-payment-note');
      if (!paymentNote) {
        paymentNote = document.createElement('span');
        paymentNote.className = 'mdc-payment-note';
        heading.appendChild(paymentNote);
      }
      paymentNote.textContent = attributeValue(payments, 'data-mdc-payment-note', 'Transactions sécurisées');
      payments.setAttribute('aria-label', attributeValue(payments, 'data-mdc-payment-aria-label', 'Moyens de paiement acceptés'));
    }

    footer.dataset.mdcCleanupReady = 'true';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrangeFooter, { once: true });
  } else {
    arrangeFooter();
  }

  document.addEventListener('shopify:section:load', arrangeFooter);
  document.addEventListener('shopify:section:reorder', function () {
    newsletterOrigin = null;
    arrangeFooter();
  });
})();
